import React, { useState, useMemo, useEffect } from "react";
import { Row, Col } from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import TextInput from "../../../custom/components/Text-Input/TextInput.js";
import CheckboxInput from "../../../custom/components/CheckBox-Input/CheckboxInput.js";
import CustomForm from "../../../custom/Forms/CustomForm.js";
import { saveRecords } from "../../../services/api.service.js";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useCreateForm from "../../../custom/Utils/UseCreateFormUtils.js";
import { createPageData } from "./CityFile.js";
import { basicFormData } from "./CityFile.js";
import { validate } from "../../../custom/validations/Validate.js";
import SelectInput from "../../../custom/components/Select-Input/SelectInput.js";

const CityCreate = () => {
  const navigate = useNavigate();
  let { id } = useParams();
  const {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
    dependentDropdownData,
  } = createPageData();
  const [loadingData, setLoadingData] = useState(false);
  const initialPayload = useMemo(() => payload, []);

  const {
    formData,
    onInputChange,
    formErrors,
    setFormErrors,
    handleSelectChange,
    handleUserSelectChange,
    selectedDropOption,
    selectedDropdownOptions,
    setSelectedDropOption,
    setSelectedUserOption,
    selectedUserOption,
  } = useCreateForm(
    getEndpoint,
    id,
    initialPayload,
    basicFormData(),
    validationType,
    dependentDropdownData
  );
  const setSelectedOption = (options, value, setSelected) => {
    const matchedOption = options.find((option) => option.value === value);
    setSelected(
      matchedOption
        ? { label: matchedOption.label, value: matchedOption.value }
        : null
    );
  };
  useEffect(() => {
    if (selectedDropdownOptions.length) {
      setSelectedOption(
        selectedDropdownOptions[0]?.options,
        formData.inputData.state_id,
        setSelectedDropOption
      );
    }
  }, [formData.inputData.state_id, selectedDropdownOptions]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoadingData(true);

    try {
      const validationErrors = validate(validationType, formData.inputData);

      if (Object.keys(validationErrors).length > 0) {
        setLoadingData(false);
        setFormErrors(validationErrors);
        return;
      }

      const isCreating = !id;
      const userDetails = JSON.parse(localStorage.getItem("userDetails"));

      const payload = {
        id,
        modelName: initialPayload?.modelName,
        inputData: {
          ...formData.inputData,
          created_by: isCreating
            ? userDetails.id
            : formData.inputData.created_by,
          updated_by: userDetails.id,
        },
      };

      console.log("payload", payload);

      const responseData = id
        ? await saveRecords(payload, updateEndpoint)
        : await saveRecords(payload, createEndpoint);

      if (responseData && responseData.code === 1) {
        toast.success(
          `${headerName} ${id ? "updated" : "saved"} successfully!`
        );
        navigate(navigatePage?.back);
      } else {
        toast.error(
          responseData?.message ||
            `Error while ${id ? "updating" : "saving"} ${headerName}!`
        );
      }
    } catch (error) {
      console.error("Error during submission:", error);
      toast.error("An unexpected error occurred. Please try again.");
    } finally {
      setLoadingData(false);
    }
  };

  return (
    <CustomForm
      title={id ? "UPDATE " + headerName : "CREATE " + headerName}
      loadingData={loadingData}
      onFormSubmit={handleSubmit}
      handleBackClick={() => navigate(navigatePage?.back)}
      id={id}
    >
      <Row className="mt-2">
        <Col md="6" className="mt-3">
          <SelectInput
            label="State"
            name="state_id"
            value={selectedDropOption}
            options={selectedDropdownOptions}
            onSelect={handleSelectChange}
            placeholder="Select State"
            parentClassName=""
            selectClassName=""
            labelClassName="form-label"
            parentStyle={{}}
            selectStyle={{}}
            labelStyle={{}}
            size={1}
            noDataMessage="data not found"
            maxMenuHeight={200}
            isClearable={false}
            customError={formErrors.state_id}
            asterisk={true}
          />
        </Col>
        <Col md="6" className="mt-3">
          <TextInput
            label="City Name"
            name="city_name"
            value={formData.inputData.city_name}
            onChange={onInputChange}
            placeholder="City name"
            inputClassName="form-control "
            labelClassName="form-label"
            autocomplete={"off"}
            customError={formErrors.city_name}
            asterisk={true}
          />
        </Col>
      </Row>
      <Row className="mt-3">
        <Col lg="12">
          <CheckboxInput
            label="Is Active"
            name="is_active"
            value={formData.inputData.is_active}
            checked={formData.inputData.is_active}
            handleTextChange={onInputChange}
            parentClassName="form-check"
            checkBoxClassName="form-check-input"
            labelClassName="form-check-label"
            disabled={false}
            required={false}
            customError={formErrors.is_active}
          />
        </Col>
      </Row>
    </CustomForm>
  );
};
export default CityCreate;
